import { Controller } from "@hotwired/stimulus"
import "bootstrap-datepicker"

export default class extends Controller {
  connect() {
    this.initDatepicker()
  }

  initDatepicker() {
    if(this.element.classList?.contains('month-datepicker')) {
      this.initMonthDatepicker(this.element);
    } else {
      this.initGeneralDatepicker(this.element);
    }
  }

  initGeneralDatepicker(datepickerElement) {
    let $element = $(datepickerElement);
    const todayBtn = $element[0].classList?.contains('todayBtn') ? 'linked' : false

    window.dateConvertor($element);


    let options = {
      disableTouchKeyboard: false,
      autoclose: true,
      format: window.userPreferenceDateFormat.toLowerCase(),
      clearBtn: true,
      todayBtn
    };

    // Catch change event when you change via datepicker.
    $element.datepicker(options).on('changeDate', (e) => {
      const element = $('#' + e.target.id);
      this.setHiddenInputValue(element);
    });

    // Catch the change event when you change via writing on the input.
    $element.on('change', (e) => {
      const element = $('#' + e.target.id);
      this.setHiddenInputValue(element);
    });
  }

  initMonthDatepicker(datepickerElement) {
    let $monthDatepicker = $(datepickerElement);

    function init($this) {
      let options = {
        defaultDate: Date.now(),
        viewMode: 'months',
        minViewMode: 'months',
        format: 'MM yyyy',
        todayHighlight: true,
        showClear: true
      };

      $this.datepicker(options);
    }

    init($monthDatepicker);
  }

  setHiddenInputValue(element) {
    const hiddenElement = $(`input[name='${element.attr('name')}'][type='hidden']`);

    const date_string = element.val();
    const date_formatter = window.dateFormatter(date_string, window.userPreferenceDateFormat, window.serverSideDateFormat);
    hiddenElement.val(date_formatter);
  }

}
